<template>
  <div class="custom-tabs">
    <ul class="custom-tabs-ul">
      <li class="custom-tabs-li custom-tabs-li--all" :class="{ active: value === -1 }" @click="onClick(null, -1)">
        <span>{{ $t('Common.com_all') }}</span>
      </li>
      <li class="custom-tabs-li" v-for="(item, index) in data" :key="index" :class="{ active: index === value, 'active-move': index === value }" @click="onClick(item, index)">
        <span>{{ item.label }}</span>
        <div class="func-group">
          <i class="icon icon-shanchu" @click="onDelete(index)"></i>
          <i v-if="!disabled" class="icon icon-bianji" @click="onEdit(index)"></i>
        </div>
      </li>
      <li class="custom-tabs-li custom-tabs-li--add" v-if="add && !disabled" @click="onAdd">
        <i class="icon icon-add"></i>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    // 是否显示添加按钮
    add: {
      type: Boolean,
      default: false,
    },
    // [{label}]
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    // v-model, activeIndex
    value: {
      type: Number,
      default: 0,
    },
    // 如果为true时，禁止编辑
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick(item, index) {
      this.$emit('input', index);
      this.$emit('change', item);
    },
    onAdd() {
      this.$emit('add');
    },
    onEdit(index) {
      this.$emit('edit', index);
    },
    onDelete(index) {
      this.$emit('delete', index);
    },
  },
  mounted() {

  },
};
</script>

<style lang="scss">
$borderColor: #eef2f8;
.custom-tabs {
  position: relative;
  width: 100%;

  &::after {
    content: ' ';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1px;
    left: 0;
    background: $borderColor;
  }

  .custom-tabs-ul {
    overflow: hidden;
    position: relative;
    z-index: 10;

    .custom-tabs-li {
      height: 40px;
      line-height: 38px;
      font-size: 12px;
      text-align: center;
      color: #495057;
      padding: 0 20px;
      float: left;
      border: 1px solid $borderColor;
      position: relative;
      transition: all 0.3s;

      &.active {
        color: #0d9ae0;
        border-bottom: 1px solid #fff;

        &:before {
          content: ' ';
          position: absolute;
          height: 2px;
          background: #0d9ae0;
          left: -1px;
          right: -1px;
          top: -1px;
          margin: auto;
        }
      }

      &.active-move {
        &:not(.custom-tabs-li--all) {
          padding-right: 102px;
        }

        .func-group {
          position: absolute;
          right: 0;
          top: 0;

          .icon {
            float: right;
            margin-right: 10px;
          }
        }
      }

      &:hover {
        cursor: pointer;
      }

      &:nth-child(n + 2) {
        border-left: none;
      }

      &.custom-tabs-li--add {
        width: 40px;
        padding: 0;
        color: #0d9ae0;
      }
    }
  }
}
</style>
